import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';
import { InlineButton } from '../InlineButton';

export interface IChangePhoneProps {
  phone: string;

  onChangeClick(): void;
}

export const ChangePhone: React.FC<IChangePhoneProps> = ({ phone, onChangeClick }) => {
  return (
    <div>
      <InlineText2>Введите код, который мы отправили на номер</InlineText2>
      <InlineText2 whiteSpace="nowrap"> {phone} </InlineText2>
      <InlineButton onClick={onChangeClick}>Изменить номер</InlineButton>
    </div>
  );
};

ChangePhone.displayName = 'ChangePhone';
